import { styled } from '@mui/material';
import { ContentIsland, ContentIslandProps } from './ContentIsland';

const TextContainer = styled('div', {
  name: 'TextContentIsland',
  slot: 'container',
})(({ theme }) => ({
  display: 'flex',
  alignContent: 'center',
  justifyContent: 'center',
  padding: theme.spacing(3, 4),
}));

export function TextContentIsland({ children, ...props }: ContentIslandProps) {
  return (
    <ContentIsland {...props}>
      <TextContainer>{children}</TextContainer>
    </ContentIsland>
  );
}
